"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.65 3.755a6 6 0 0 1 .7 0 .7.7 0 1 1-.077 1.398 5 5 0 0 0-.546 0 .7.7 0 1 1-.077-1.398m3.53 1.637a.7.7 0 0 1 .988-.055q.262.232.495.495a.7.7 0 1 1-1.043.933 5 5 0 0 0-.385-.385.7.7 0 0 1-.056-.988m2.327 3.597a.7.7 0 0 1 .738.66 6 6 0 0 1 0 .701.7.7 0 1 1-1.398-.077 5 5 0 0 0 0-.546.7.7 0 0 1 .66-.738m-11.014 0a.7.7 0 0 1 .66.738 5 5 0 0 0 0 .546.7.7 0 0 1-1.398.077 6 6 0 0 1 0-.7.7.7 0 0 1 .738-.66m.899 4.19a.7.7 0 0 1 .988.056q.182.203.385.385a.7.7 0 0 1-.933 1.044 6 6 0 0 1-.496-.496.7.7 0 0 1 .056-.989m3.597 2.328a.7.7 0 0 1 .738-.66 5 5 0 0 0 .546 0 .7.7 0 1 1 .077 1.398 6 6 0 0 1-.7 0 .7.7 0 0 1-.66-.738M3 3.7a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7zm1.4.7v2.8h2.8V4.4zm7 7.7a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7h-4.2a.7.7 0 0 1-.7-.7zm1.4.7v2.8h2.8v-2.8z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ProofCircleDashedIcon20.js.map